export default __webpack_public_path__ + "./image/58c52694719bb9f6c7138b2406aa4a10.png";